import { Link } from 'react-router-dom';

export default function ForbiddenPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center max-w-7xl mx-auto px-4 py-16 text-center">
      <div className="max-w-md p-8 sm:p-10 rounded-2xl bg-white border border-stone-200 shadow-lg space-y-6">
        <div className="w-16 h-16 rounded-2xl bg-red-50 border border-red-200 text-red-600 flex items-center justify-center text-3xl mx-auto">
          <i className="fa-solid fa-lock"></i>
        </div>

        <div className="space-y-2">
          <span className="text-xs font-bold uppercase tracking-widest text-red-600">Fejl 403</span>
          <h1 className="text-3xl font-extrabold text-stone-900">Adgang Nægtet</h1>
          <p className="text-stone-600 text-sm leading-relaxed">
            Du har ikke tilladelse til at tilgå denne ressource.
          </p>
        </div>

        <div className="pt-2">
          <Link
            to="/"
            className="w-full py-3 px-4 rounded-none bg-stone-900 hover:bg-black text-white font-bold text-sm block transition-colors shadow-lg"
          >
            <i className="fa-solid fa-house mr-2"></i> Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
